import { Analytics } from '@cobliteam/analytics/src/Analytics';
import { Button, Dialog, Link, Typography } from '@cobliteam/ui/components';
import Icon from '@cobliteam/ui/icons';

const FaceRecognitionDialog = () => {
  const handleModalOpenChange = (open: boolean) => {
    if (open) {
      Analytics.track('Driver Cluster Drawer Opened');
    }
  };

  return (
    <Dialog onOpenChange={handleModalOpenChange}>
      <Dialog.Trigger asChild>
        <Button variant='ghost' size='sm' color='default' icon={<Icon name='info' />} />
      </Dialog.Trigger>
      <Dialog.Content>
        <Dialog.Header>
          <Dialog.Title>Nomear fotos dos motoristas</Dialog.Title>
          <Dialog.Description className='sr-only' />
          <Dialog.Close />
        </Dialog.Header>
        <Dialog.Body className='flex flex-col gap-3'>
          <Typography variant='body'>
            Nomear os grupos de fotos dos motoristas não identificados auxilia no reconhecimento de detecções automáticas. Quanto mais grupos de fotos forem nomeados, mais
            condutores serão identificados.
          </Typography>

          <div className='flex flex-col gap-1'>
            <Typography variant='description-title'>Como identificar motoristas em grupos de fotos não reconhecidas?</Typography>
            <Typography variant='body'>
              <ul className='list-disc pl-4'>
                <li>
                  Vá em{' '}
                  <strong>
                    'Minha frota {'>'} Motoristas {'>'} Motoristas não identificados'
                  </strong>
                  . Na aba você visualizará todos os grupos de fotos que o algoritmo não reconheceu um motorista.
                </li>
                <li>Revise as fotos do grupo, remova caso haja alguma que não corresponde ao motorista.</li>
                <li>Busque e selecione o motorista cadastrado correspondente ou se necessário, cadastre um novo.</li>
              </ul>
            </Typography>
          </div>

          <div className='flex flex-col gap-1'>
            <Typography variant='description-title'>Minha câmera não está identificando as fotos, o que fazer?</Typography>
            <Typography variant='body'>
              É necessário aguardar algumas viagens para que a câmera tire fotos e agrupe. Se mesmo assim sua câmera não registrar fotos verifique se:
            </Typography>

            <Typography variant='body'>
              <ul className='list-disc pl-4'>
                <li>A câmera está bem posicionada, apontando para o rosto do motorista;</li>
                <li>Existem objetos que estão na frente da câmera;</li>
              </ul>
            </Typography>
          </div>

          <div className='flex items-center gap-1 rounded-md bg-gray-2 p-3'>
            <Typography variant='body'>Acesse mais informações sobre a identificação de condutores na nossa</Typography>
            <Link href='https://suporte.cobli.co/reconhecimento-facial-motorista' target='_blank' size='sm' rel='noopener noreferrer'>
              central de ajuda
            </Link>
            <Typography variant='body'>.</Typography>
          </div>
        </Dialog.Body>
      </Dialog.Content>
    </Dialog>
  );
};

export default FaceRecognitionDialog;
